// extracted by mini-css-extract-plugin
export default {"container":"Iz-z","dimension":"Jz-z","dimensionLabels":"Kz-z"};